import $ from 'jquery'; 
const Dispatcher = require('./../Dispatcher');
const Constants = require('./../Constants');

const PopupActions = {
  populate: (people) => {
    Dispatcher.dispatch({
      actionType: Constants.EVENT_POPULATE_POPUP,
      people: people
    });
  },

  open: (index) => {
    Dispatcher.dispatch({
      actionType: Constants.ACTION_OPEN_POPUP,
      index: index
    });
  },

  close: () => {
    Dispatcher.dispatch({
      actionType: Constants.ACTION_CLOSE_POPUP
    });
  },

  closeViaMask: (event) => {
    if ($(event.target).hasClass('mask')) {
      Dispatcher.dispatch({
        actionType: Constants.ACTION_CLOSE_POPUP
      });
    }
  },

  navigateRight: () => {
    Dispatcher.dispatch({
      actionType: Constants.ACTION_NAVIGATE_RIGHT
    });
  },

  navigateLeft: () => {
    Dispatcher.dispatch({
      actionType: Constants.ACTION_NAVIGATE_LEFT
    });
  }
};

export default PopupActions;
